<template>
  <div class="dashboard-container">
    <h1>成绩列表</h1>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'


export default {
  name: 'LeagueList',
  computed: {
  },
  methods: {
    handleRolesChange() {

    },
    goTeams() {
      this.$router.push({ name: 'LeagueGroupTeams', params: { id: 1, gid: 1 }})
    },
    goGames() {
      this.$router.push({ name: 'LeagueGroupGames', params: { id: 1, gid: 1 }})
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.dashboard {
  &-container {
    margin: 30px;
  }
  &-text {
    font-size: 30px;
    line-height: 46px;
  }
}
</style>
